export default __webpack_public_path__ + "static/media/RisePhoenix.ba56cf66.png";